import { COMMON } from "../../../util/localizations"

const TRANSLATIONS = {
    en: {
        approved: 'Approved',
        approve: "Approve",
        badOffer: `You are not approved to buy.`,
        badOfferAmount: `The submitted amount in this request was not approved.`,
        buy: 'Buy',
        etherscan: COMMON.en.etherscan,
        offerApproved: 'Offer for {0} on token {1} was successfully approved.',
        offerRejected: 'Offer for {0} on token {1} was successfully rejected.',
        pending: 'Awaiting seller action...',
        purchased: 'Purchased!',
        rejected: 'Rejected',
        reject: "Reject",
        sold: 'Sold!',
        successfulPurchase: 'Successfully purchased {0}! View it on {1}.'
    }
}

export default TRANSLATIONS